export class UrlConstants {
  public static SEPARATOR = '/';
  public static NEW = 'new';
  public static EDIT = 'edit';
  public static OBJECT_ID = ':id';

  public static HOME_PAGE = '';
  public static HOME_PAGE_FAQ = 'faq';

  public static DASHBOARD = 'dashboard';

  public static ORDERS = 'orders';
  public static ORDERS_UNIT = 'unit';
  public static ORDERS_AGGREGATED = 'aggregated';

  public static TAX = 'tax';
  public static TAX_LEVELS = 'tax-levels';
  public static TAX_MONITOR = 'tax-monitor';

  public static UID_CHECK = 'check-uid';

  public static EXTERNAL = 'external';

  public static ECONOMIC_OPERATORS = 'economic-operators';
  public static ECONOMIC_OPERATORS_EXTERNAL_VALIDATE = UrlConstants.EXTERNAL + UrlConstants.SEPARATOR + UrlConstants.ECONOMIC_OPERATORS + UrlConstants.SEPARATOR + 'validate';

  public static FACILITIES = 'facilities';
  public static MACHINES = 'machines';

  public static PRODUCTION = 'production';
  public static MY_REQUESTS = 'my-requests';
  public static FOLLOWUP = 'followup';
  public static PRODUCTION_MY_REQUESTS = UrlConstants.SEPARATOR + UrlConstants.PRODUCTION + UrlConstants.SEPARATOR + UrlConstants.MY_REQUESTS;
  public static PRODUCTION_FOLLOWUP = UrlConstants.SEPARATOR + UrlConstants.PRODUCTION + UrlConstants.SEPARATOR + UrlConstants.FOLLOWUP;

  public static APPROVALS = 'approvals';
  public static PENDING_APPROVALS = 'pending-approvals'
  public static PRODUCTS = 'products';
  public static STAMPS = 'stamps';
  public static DOMAIN= 'domain';
  public static TYPE= 'type';
  public static FORM_MANAGEMENT = 'form-management';
  public static PRODUCT_APPROVALS = UrlConstants.PRODUCTS + UrlConstants.SEPARATOR + UrlConstants.APPROVALS;
  public static PRODUCT_FORM_MANAGEMENT = UrlConstants.PRODUCTS + UrlConstants.SEPARATOR + UrlConstants.FORM_MANAGEMENT;

  public static EXCISE_WAREHOUSES = 'excise-warehouses';
  public static EXCISE_WAREHOUSES_REPORTING = 'reporting';
  public static EXCISE_WAREHOUSES_DELAYED = 'delayed';
  public static EXCISE_WAREHOUSES_VALIDATION = 'validation';

  public static REPORTING = 'reporting';
  public static ADVANCED_REPORTING = 'advanced-reporting';

  static MONITORING = 'monitoring';
  public static AUDIT_TRAIL = UrlConstants.MONITORING + UrlConstants.SEPARATOR + 'audit';
  public static TRACK_AND_TRACE = 'track-and-trace';

  public static CHANGE_LOGS = 'change-logs';

  public static USERS = 'users';
  public static ADMIN_SETTINGS = 'admin-settings';
  public static USER_ADMINISTRATION = 'user-administration';

  public static SETTINGS = 'settings';
  public static WORKING_DAYS = 'working-days';
  public static PRODUCT_TYPES = 'product-types';
  public static PRODUCT_DOMAIN= 'product-domain';
  public static SETTINGS_WORKING_DAYS = UrlConstants.SEPARATOR + UrlConstants.SETTINGS + UrlConstants.SEPARATOR + UrlConstants.WORKING_DAYS;
  public static SETTINGS_PRODUCT_TYPES = UrlConstants.SEPARATOR + UrlConstants.SETTINGS + UrlConstants.SEPARATOR + UrlConstants.PRODUCT_TYPES;

  public static ACCOUNT = 'account';

  public static LOGIN = 'login';
  public static CREATE_ACCOUNT = 'create-account';
  public static RESET_PASSWORD = 'reset-password';
  public static CONTACT = 'contact';
  public static TERMS_AND_CONDITIONS = 'terms-and-conditions';
  public static TERMS_OF_USE = 'terms-of-use';
  public static PRIVACY_POLICY = 'privacy-policy';
  public static MOBILE_APP_DATA_PRIVACY_POLICY = 'mobile-app-data-privacy-policy';
  public static STATIC_LANG_DASH_EN = '-en';
  public static STATIC_LANG_DASH_ES = '-es';

  public static SAGA_OPERATIONS = 'saga-operations';

  public static ENTITY_APPROVALS = 'pending-approvals';

  public static MESSAGES = 'messages';
  public static DOCUMENTATION = 'documentation';
  public static REGISTRY_REPORT = 'registry-report';
  public static TAX_REPORT = 'tax-report';

  public static buildUrl(...args: any[]) {
    let url = this.SEPARATOR;
    args.forEach(part => url = url + part + this.SEPARATOR);
    return url;
  }

}
